import '../styles/index.scss';
import 'slick-carousel/slick/slick';
import 'jquery.nicescroll/jquery.nicescroll';
import 'bootstrap';
import functions from './functions';
import rotatingBanners from './rotating-banners';

class Main {
    constructor() {
        this.onDOMLoaded();
        this.onDocumentLoad();
        this.onResize();
        this.onScroll();
        window.jQuery = window.$ = $;
    }

    onDocumentLoad() {
        window.addEventListener("load", (event) => {
            functions.filterTabs();
            functions.verticalFilter();
            functions.accordion();
            functions.searchBar();
            functions.slider();
            functions.simpleSlider();
            functions.faqItem();
            functions.mediapointSlider();
        });
    }

    onDOMLoaded() {
        document.addEventListener("DOMContentLoaded", (event) => {
            functions.cookies();
            functions.setupHexagonLinks();
            functions.setupMediapointBlogLoadMoreButton();

            rotatingBanners.setup();
        });

    }

    onResize() {
        window.addEventListener('resize', (event) => {

        });
    }

    onScroll() {
        window.addEventListener('scroll', (event) => {

        });
    }

}

new Main();


